// @ts-nocheck
/* eslint-disable spire/export-styles */
// import getLocalizedCurrency from "@insite/client-framework/Common/Utilities/getLocalizedCurrency";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { CurrencyPositioningType, LanguageModel } from "@insite/client-framework/Types/ApiModels";
import React, { FC } from "react";
import { connect } from "react-redux";

interface OwnProps {
    amount: number;
    currencySymbol?: string;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    language: state.context.session.language,
    currencySymbol: ownProps.currencySymbol ?? state.context.session.currency?.currencySymbol,
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

interface GetLocalizedCurrencyProps {
    amount: number;
    currencySymbol: string;
    language: LanguageModel;
}

// bunzl custom code - Helper function isn't using an actual currency localizer so its missing
export const getLocalizedCurrency = ({ amount, language, currencySymbol }: GetLocalizedCurrencyProps) => {
    const locale = language.cultureCode || language.languageCode;
    const options = {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };
    let currencyFormatter;
    try {
        currencyFormatter = new Intl.NumberFormat(locale, options);
    } catch {
        currencyFormatter = new Intl.NumberFormat(undefined, options);
    }

    // format the same way as CurrencyFormatProvider in the .NET code
    const negativeSymbol = amount < 0 ? "-" : "";
    const amountStrWithoutNegativeSign = currencyFormatter.format(Math.abs(amount));

    return language.currencyPositioning === CurrencyPositioningType.Left
        ? `${negativeSymbol}${currencySymbol}${amountStrWithoutNegativeSign}`
        : `${negativeSymbol}${amountStrWithoutNegativeSign} ${currencySymbol}`;
};

/**
 * This component will return a currency amount formatted with the session currency and language.
 * This component should only be used in cases where the formatted currency amount cannot be generated server side.
 *
 */
const LocalizedCurrency: FC<Props> = ({ amount, language, currencySymbol }) => {
    if (!language || !currencySymbol) {
        return null;
    }

    return <>{getLocalizedCurrency({ amount, language, currencySymbol })}</>;
};

export default connect(mapStateToProps)(LocalizedCurrency);
